(function($) {

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        $('body').addClass('in-mobile');
    }

    $(document).ready(function() {

        var $body = $('body'),
            screenWidth = $( window ).width(),
            contactFormTop = $('#contact-msg textarea').offset(),
            scrollPos = "";

        if(screenWidth <= 767) {
            $body.addClass('width-mobile');
        }else if(screenWidth >= 767 && screenWidth <= 1200 ) {
            $body.addClass('width-tablet');
        }else{
            $body.removeClass('width-mobile');
            $body.removeClass('width-tablet');
        }

        $( window ).resize(function() {
            var screenWidth = $( window ).width();
            if(screenWidth <= 767) {
                $body.addClass('width-mobile');
            }else if(screenWidth >= 767 && screenWidth <= 1200 ) {
                $body.addClass('width-tablet');
            }else{
                $body.removeClass('width-mobile');
                $body.removeClass('width-tablet');
            }
            //Refermer le menu mobile lors du resize car cause parfois des glitch quand on passe de mobile a desktop
            if($('.hamburger').hasClass("is-active")) {
                $('.hamburger').trigger('click');
            }
        });

        var topBarHeight = $('.top-bar-main').outerHeight(true);
        $('body').on('click', '.scroll-to', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            scrollTo( $(target) );
        });

        function scrollTo(elm){
            $('html, body').animate({
                scrollTop: $(elm).offset().top - topBarHeight
            }, 1000);
        }



        var jstypedTriggered = false;
        $( window ).scroll(function() {

            var bottomPos = $(window).scrollTop() + $(window).height()
            if(bottomPos >= (contactFormTop.top + 50)){

                if(!jstypedTriggered){
                    jstypedTriggered = true;
                    var typed = new Typed('textarea', {
                        strings: ["Bonjour Tom,\n\n``"],
                        typeSpeed: 80,
                        showCursor: false,
                    });
                    //mettre un delais pour pas que sa focus tout de suite
                    //$('textarea').focus()
                }
            }

        });

        //TOGGLE HAMBURBER MENU
        $body.on('click', '.hamburger', function (e) {
            $(this).toggleClass('is-active');
            $("#header").toggleClass("open-nav");
            $(".circle").toggleClass("open");
            //$("html, body").toggleClass("body-no-overflow");
            $("body").toggleClass("body-no-overflow");
        });



        /* SOURCE : https://codeable.io/wordpress-accessibility-creating-accessible-dropdown-menus */
        // Focus styles for menus when using keyboard navigation
        $('nav[role="navigation"]').focus();
        // Properly update the ARIA states on focus (keyboard) and mouse over events
        $( '[role="menubar"]' ).on( 'focus.aria  mouseenter.aria', '[aria-haspopup="true"]', function ( ev ) {
            $( ev.currentTarget ).attr( 'aria-expanded', true );
        } );

        // Properly update the ARIA states on blur (keyboard) and mouse out events
        $( '[role="menubar"]' ).on( 'blur.aria  mouseleave.aria', '[aria-haspopup="true"]', function ( ev ) {
            $( ev.currentTarget ).attr( 'aria-expanded', false );
        } );

        //Ajouter le dot qui bouge
        $('#main-nav .menu').append("<div class='dot-ctn'><span class='dot'></span><span class='center-dot'></span></div>");
        //Ajouter les class sur les liens du menu
        $('#main-nav .menu > .menu-item:nth-child(1) a').addClass('link01 link-home');

        //Le 2ieme lien n'est pas clickable mais ses enfant le sont
        $('#main-nav .menu >.menu-item:nth-child(2) a').not(".sub-menu a").addClass('link02 no-click');
        $('#main-nav .menu > .menu-item:nth-child(3) a').addClass('link03');

        $('#main-nav .menu .menu-item .sub-menu a').each(function( index ) {
            $(this).addClass('link02');
        });

        //TODO: Mettre le dot dessus le lien clicker pour ne pas quil retourne a sa position initial
        $body.on('click', '#main-nav .menu a:not(".no-click")', function (e) {
            e.preventDefault(); //for test purpose only
            $(".dot-ctn").addClass("circle-pop");
            setTimeout(function(){
                $(".dot-ctn").removeClass("circle-pop");
            }, 2500);
        });



        var currentPage = $('#main-nav .menu').find('.current_page_item a').attr('class');

        switch(currentPage) {
            case "link01":
                $(".dot-ctn").addClass("pos01");
                break;
            case "link02":
                $(".dot-ctn").addClass("pos02");
                break;
            case "link03":
                $(".dot-ctn").addClass("pos03");
                break;
            default:
                $(".dot-ctn").addClass("pos1");
                break;
        }




        if($('#home-slider').length){

            $('#home-slider').slick({
                //mobileFirst: true,
                dots: false,
                arrow: false,
                cssEase: 'ease',
                swipe: false,
                infinite: false,
                swipeToSlide: false,
                touchMove: false,
                draggable: false,
                dot: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: "unslick"

                    },
                ]
            });
        }

        if($('#home-slider-mobile').length){

            $('#home-slider-mobile').slick({
                mobileFirst: true,
                dots: false,
                arrow: false,
                cssEase: 'ease',
                swipe: false,
                infinite: false,
                swipeToSlide: false,
                touchMove: false,
                draggable: false,

                responsive: [
                    {
                        breakpoint: 768,
                        settings: "unslick"

                    },
                ]
            });
        }


        function startTimer(duration, $display) {
            var timer = duration, minutes, seconds;

            var interval = setInterval(function () {
                minutes = parseInt(timer / 60, 10);
                seconds = parseInt(timer % 60, 10);

                minutes = minutes < 10 ? '0' + minutes : minutes;
                seconds = seconds < 10 ? '0' + seconds : seconds;

                if($body.hasClass('width-mobile')) {
                    $display.text( minutes + ':' + seconds );
                    $display.html( $display.text().replace(/([^\x00-\x80]|\w)/g, '<span>$&</span>') );
                }else {
                    $display.text( '00:' + minutes + ':' + seconds );
                    $display.html( $display.text().replace(/([^\x00-\x80]|\w)/g, '<span>$&</span>') );
                }


                if (--timer < 0) {
                    timer = duration;
                }

                if (minutes == 0 && seconds == 0) {
                    $display.parents('.chrono').addClass('time-up');
                    clearInterval( interval );
                }

            }, 1000);
        }

        $body.on('click', '.link-chrono', function (e) {
            var sectionID = $(this).data('chrono');
            if( !$('#' + sectionID + ' .chrono').hasClass('timer-started')) {
                startTimer(parseInt($('#' + sectionID).find('.timer').data('delay')), $('#' + sectionID).find('.timer'));
                $('#' + sectionID + ' .chrono').addClass('timer-started');
            }
        });


        scrollSpyChrono();
        function scrollSpyChrono(){
            $('.chrono').each(function(i) {
                var position = $(this).position();
                var minPos = 0;
                if($('body').hasClass('width-mobile')){
                    minPos = 300;
                }else{
                    minPos = 700;
                }
                $(this).scrollspy({

                    min: position.top - minPos,
                    max: position.top + $(this).height() - topBarHeight,
                    onEnter: function(element, position) {
                        if( !$(element).hasClass('timer-started')){
                            startTimer( parseInt( $(element).find('.timer').data('delay') ), $(element).find('.timer') );
                            $(element).addClass('timer-started');
                        }

                    }

                });
            });
        }


        //Filter pour les projets
        $body.on('click', '.btn-filter', function (e) {
            $(this).parent().addClass('selected').siblings().removeClass('selected');
            var cat = $(this).data('category');
            console.log(cat);
            if(cat === 'all'){
                $('.project-ctn').removeClass('hideMe');
            }else {
                $('.project-ctn').addClass('hideMe');
                $('.' + cat).removeClass('hideMe');

            }
        });

        var pageUrl = "";
        $body.on('click', '.open-modal-project', function (e) {
            e.preventDefault();

            scrollPos = $(window).scrollTop();
            $body.addClass('no-overflow');
            $('html').addClass('no-overflow');
            $('#header').addClass('hide-header');

            var $modal = $('#modal'),
                $slug = $(this).attr('href').substr(1),
                $modalContent = $modal.find('.modal-content');

            pageUrl = window.location.pathname;
            window.history.pushState($slug, "", $slug);

            $modal.removeClass('closeModal');
            $modal.addClass('open');

            $('#modal .close-modal').removeClass('anim-close');


            if( $('body').hasClass('width-mobile') || $('body').hasClass('width-tablet') ){
                $('#modal .modal-inner').addClass('openModal');
            }else{
                //$modal.addClass('openModalProject');
                $modal.addClass('openModal');
            }

            $('.please-wait').show();
            $modalContent.html('');

            var $projectCtn = $(this).parents('.project-ctn');
            $projectCtn.addClass('open-modal');


            $.ajax({
             url: themosis.ajaxurl,
             type: 'POST',
             dataType: 'json',
             data: {
                 action: 'render_project',
                 security: $('main').data('wpnonce'),
                 projectId: $projectCtn.data('projectid')
             }
            }).done(function(data){
                $('.please-wait').hide();
                $modalContent.html(data.content);
                document.title = 'Tom & Tom ';
            });

        });

        $body.on('click', '.close-modal', function (e) {

            var $slug = { slug: "" };
            window.history.pushState($slug, "", pageUrl);
            $(window).scrollTop(scrollPos);
            $body.removeClass('no-overflow');
            $('html').removeClass('no-overflow');
            $('.open-modal').removeClass('open-modal');
            $('.open').removeClass('open-modal');
            //$('#modal').removeClass('openModalProject');
            $('#modal').removeClass('openModal');
            $('#modal').addClass('closeModal');
            $(this).addClass('anim-close');

                setTimeout(function () {
                    $(this).parents('.project-ctn').removeClass('open-modal');
                    $('#modal').removeClass('open');
                    $('#header').removeClass('hide-header');
                }, 1000);

        });

        $body.keydown(function(e) {
            if (e.keyCode === 27) {
                $('.close-modal').trigger('click');
            }
        });

        window.onpopstate = function (event) {
            if (location.hash == '') {
                $('.close-modal').trigger('click');
            }
        };

        $body.on('click', '.div-close-modal', function (e) {
            $('.close-modal').trigger('click');
        });
        $body.on('click', '.black-bar', function (e) {
            $('.close-modal').trigger('click');
        });

        $body.on('click', '#open-modal-service', function (e) {
            e.preventDefault();
            var $modalService = $('#modal-service');
            var $slug = $(this).attr('href').substr(1);

            scrollPos = $(window).scrollTop();

            $body.addClass('no-overflow');
            $('html').addClass('no-overflow');
            window.history.pushState($slug, "", $slug);

            $("#modal-service .close-modal").removeClass('anim-close');

            $modalService.removeClass('closeModal');
            $modalService.addClass('open');

            if( $('body').hasClass('width-mobile') || $('body').hasClass('width-tablet') ){
                $('#modal-service .modal-inner').addClass('openModal');
            }else{
                $modalService.addClass('openModal');
            }
            $('#header').addClass('hide-header');
        });

        $body.on('click', '#modal-service .close-modal', function (e) {

            var $slug = { slug: "" };
            window.history.pushState($slug, "", '/');
            $body.removeClass('no-overflow');
            $('html').removeClass('no-overflow');

            $('#modal-service').addClass('closeModal');
            $('#modal-service').removeClass('open-modal');

            $(this).addClass('anim-close');

            if( $('body').hasClass('width-mobile') || $('body').hasClass('width-tablet') ){
                $('#modal-service .modal-inner').removeClass('openModal');
            }else{
                $('#modal-service').removeClass('openModal');
            }
            setTimeout(function(){
                $('#modal-service').removeClass('open');
            }, 600);

        });

        $body.on('click', '#open-modal-testimonial', function (e) {
            e.preventDefault();
            var $modalTestimonial = $('#modal-testimonial');
            var $slug = $(this).attr('href').substr(1);
            scrollPos = $(window).scrollTop();

            $body.addClass('no-overflow');
            $('html').addClass('no-overflow');
            $("#modal-testimonial .close-modal").removeClass('anim-close');

            window.history.pushState($slug, "", $slug);
            $modalTestimonial.addClass('open');
            $('#modal-testimonial').removeClass('closeModal');
            $('#modal-testimonial .modal-inner').addClass('openModal');

            if( $('body').hasClass('width-mobile') || $('body').hasClass('width-tablet') ){
                $('#modal-testimonial .modal-inner').addClass('openModal');
            }else{
                $modalTestimonial.addClass('openModal');
            }


            $('#header').addClass('hide-header');
        });

        $body.on('click', '#modal-testimonial .close-modal', function (e) {
            var $slug = { slug: "" };
            window.history.pushState($slug, "", '/');

            $('#modal-testimonial').removeClass('open-modal');
            $body.removeClass('no-overflow');
            $('html').removeClass('no-overflow');
            $(this).addClass('anim-close');

            $('#modal-testimonial').addClass('closeModal');
            $('#modal-testimonial').removeClass('open-modal');

            if( $('body').hasClass('width-mobile') || $('body').hasClass('width-tablet') ){
                $('#modal-testimonial .modal-inner').removeClass('openModal');
            }else{
                $('#modal-testimonial').removeClass('openModal');
            }


            setTimeout(function(){
                $('#modal-testimonial').removeClass('open');
            }, 600);

        });

        var clearMainDelay = 600;
        var loadContentDelay = 1200;
    //LOADER LES PAGES EN AJAX

        //PAGE HOME

        $body.on('click', '.link-home', function (e) {
            e.preventDefault();
            if($(this).hasClass('link-home-footer')){
                if($body.hasClass('width-mobile')){
                    openPageAnimationFromCenterPortfolio();
                }else {
                    openPageAnimation();
                }
            }else{
                $(this).addClass("open");
            }



            $('.link01').parent().addClass('current_page_item').siblings().removeClass('current_page_item');
            $(".dot-ctn").removeClass('pos03').addClass("pos01");

            //
            var $slug = { slug: "" };
            window.history.pushState($slug, "", '/');

            $.ajax({
                url: themosis.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'render_page_home',
                    security: $('main').data('wpnonce'),
                }
            }).done(function(data){

                setTimeout(function(){
                    $('main').html('');
                    $('main').html(data.content);
                    $(window).scrollTop(0);

                    $(".dot-ctn").removeClass("circle-pop");
                    $('.link-home').removeClass("open");
                    $('.page-dot-ctn').removeClass("open");

                    if($body.hasClass('width-mobile')){
                        closeMenuMobile();

                        $('#home-slider-mobile').slick({
                            mobileFirst: true,
                            dots: false,
                            arrow: false,
                            cssEase: 'ease',
                            swipe: false,
                            infinite: false,
                            swipeToSlide: false,
                            touchMove: false,
                            draggable: false,
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: "unslick",

                                },
                            ]
                        });
                    }else {
                        $('#home-slider').slick({
                            dots: false,
                            arrow: false,
                            cssEase: 'ease',
                            swipe: false,
                            infinite: false,
                            swipeToSlide: false,
                            touchMove: false,
                            draggable: false,
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: "unslick",
                                },
                            ]
                        });
                    }






                    scrollSpyChrono();


                }, loadContentDelay);
                document.title = "Tom&Tom - Accueil";
            });

        });

        //PAGE CONTACT
        $body.on('click', '.link03', function (e) {
            e.preventDefault();
            openPageAnimation();

            $(this).parent().addClass('current_page_item').siblings().removeClass('current_page_item');
            $(".dot-ctn").removeClass('pos01').addClass("pos03");
            var $slug = { slug: "" };
            window.history.pushState($slug, "", '/nous-joindre');
            $.ajax({
                url: themosis.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'render_page_contact',
                    security: $('main').data('wpnonce'),
                }
            }).done(function(data){
                $(window).scrollTop(0);
                $('main').html('');

                setTimeout(function(){
                    $('main').html(data.content);

                    if($body.hasClass('width-mobile')){
                        closeMenuMobile();
                    }
                    closeMenuMobile();
                    $(".dot-ctn").removeClass("circle-pop");
                }, loadContentDelay);


                document.title = "Tom&Tom - Nous joindre";
            });

        });

        //PAGE PORTFOLIO
        $body.on('click', '#link-portfolio', function (e) {
            e.preventDefault();
            openPageAnimationFromCenterPortfolio();
            var $slug = { slug: "" };
            window.history.pushState($slug, "", '/portfolio-archive');
            $('.current_page_item').removeClass('current_page_item');
            setTimeout(function(){
                $.ajax({
                    url: themosis.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'render_page_portfolio',
                        security: $('main').data('wpnonce')
                    }
                }).done(function(data){
                    $(window).scrollTop(0);
                    $('main').html('');
                    $('main').html(data.content);
                    $('.page-dot-ctn').removeClass("open");
                    document.title = "Tom&Tom - Portfolio";
                });
            }, 3000);


        });


        //Politique
        $body.on('click', '#link-politic', function (e) {
            e.preventDefault();
            var $slug = { slug: "" };
            window.history.pushState($slug, "", '/politique-de-confidentialite');
            if($body.hasClass('width-mobile')){
                openPageAnimationFromCenterPortfolio();
            }else {
                openPageAnimation();
            }
            $.ajax({
                url: themosis.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'render_page_politic',
                    security: $('main').data('wpnonce'),
                    pageId: $(this).data('pageID')
                }
            }).done(function(data){

                setTimeout(function(){
                    $(window).scrollTop(0);
                    $('main').html('');
                    $('main').html(data.content);
                    $('.page-dot-ctn').removeClass("open");
                    $(".dot-ctn").removeClass("circle-pop");
                }, loadContentDelay);
                document.title = "Tom&Tom - Politique de confidentialité";
            });

        });

        function closeMenuMobile(){

            $("#header").removeClass("open-nav");
            $(".circle").removeClass("open");
            $('.hamburger').removeClass('is-active');

        }

        function openPageAnimation(){
            $(".dot-ctn").addClass("circle-pop");
        }

        function openPageAnimationFromCenterPortfolio(){
            $('.page-dot-ctn').addClass("open");
        }

        setInterval(function(){
            changeLogoMobile();
        }, 3000);

        function changeLogoMobile(){

            $( ".all-logo-ctn .logo-ctn.in-mobile" ).each(function( index ) {
                var delay = $(this).data('delay');
                setTimeout(function(){
                    if($('#m-logo0' + (index + 1) + ' .logo.active').next().length){
                        $('#m-logo0' + (index+1) + ' .logo.active').removeClass('active').next().addClass('active');
                    }else{
                        $('#m-logo0' + (index+1) + ' .logo').first().addClass('active').siblings().removeClass('active');
                    }
                }, delay);
            });
        }

        setInterval(function(){
            changeLogoDesktop();
        }, 6000);

        function changeLogoDesktop(){

            $( ".all-logo-ctn .logo-ctn.in-desktop" ).each(function( index ) {
                var delay = $(this).data('delay');
                setTimeout(function(){
                    if($('#d-logo0' + (index+1) + ' .logo.active').next().length){
                        $('#d-logo0' + (index+1) + ' .logo.active').removeClass('active').next().addClass('active');
                    }else{
                        $('#d-logo0' + (index+1) + ' .logo').first().addClass('active').siblings().removeClass('active');
                    }
                }, delay);
            });
        }

    });
}(jQuery));


// WEBPACK FOOTER //
// ./assets/js/theme.js